import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <span className="text-background-50 font-heading font-bold text-base">51</span>
              </div>
              <span className="text-foreground-950 font-heading font-semibold text-lg">51动漫</span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4 max-w-md">
              51动漫官网致力于为广大动漫爱好者提供最新、最全的动漫资源。无论是最新番剧、经典老片还是NBA赛事视频，这里都是您随身追更的最佳选择。永久免费，高速流畅。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/30 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/30 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/30 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/30 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-foreground-900 font-heading font-semibold text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">首页</Link></li>
              <li><Link to="/category/reboot" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">热血动漫</Link></li>
              <li><Link to="/category/love" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">恋爱动漫</Link></li>
              <li><Link to="/category/funny" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">搞笑动漫</Link></li>
              <li><Link to="/category/nba" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">NBA赛事</Link></li>
            </ul>
          </div>

          {/* Support links */}
          <div>
            <h4 className="text-foreground-900 font-heading font-semibold text-sm mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">品牌介绍</Link></li>
              <li><Link to="/about" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">用户口碑</Link></li>
              <li><Link to="/about" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">联系我们</Link></li>
              <li><a href="#" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">用户协议</a></li>
              <li><a href="#" className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200">隐私政策</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-200/50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs text-center sm:text-left">
            &copy; 2026 51动漫 版权所有 | 本站内容仅供学习和交流使用
          </p>
          <div className="flex items-center gap-4 text-foreground-400 text-xs">
            <span>永久免费看动漫</span>
            <span className="hidden sm:inline">|</span>
            <span>51动漫入口</span>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="relative overflow-hidden h-16">
        <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none select-none">
          <span className="text-foreground-950 font-heading font-bold text-6xl tracking-widest">51动漫</span>
        </div>
      </div>
    </footer>
  );
}